import "core-js/modules/es.number.constructor.js";
//
//
//
//
import echarts from 'echarts';

require('echarts/theme/macarons'); // echarts theme


import { debounce } from '@/utils';
export default {
  props: {
    className: {
      type: String,
      default: 'chart'
    },
    width: {
      type: Number,
      default: 17
    },
    height: {
      type: Number,
      default: 20
    },
    seriesData: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    xAxisData: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    isShowLegend: Boolean,
    legendData: {
      // 图例data
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      chart: null,
      option: {},
      currentSystem: '',
      txtData: [],
      sysTypeOption: []
    };
  },
  watch: {
    seriesData: {
      deep: true,
      handler: function handler(val) {
        this.initChart();
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.initChart();
    this.__resizeHanlder = debounce(function () {
      if (_this.chart) {
        _this.chart.resize();
      }
    }, 100);
    window.addEventListener('resize', this.__resizeHanlder);
  },
  beforeDestroy: function beforeDestroy() {
    if (!this.chart) {
      return;
    }

    window.removeEventListener('resize', this.__resizeHanlder);
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    initChart: function initChart() {
      var _this2 = this;

      this.chart = echarts.init(this.$el, 'macarons');
      this.option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'

          },
          formatter: function formatter(params) {
            return params[0].value + '份';
          }
        },
        legend: {
          show: this.isShowLegend,
          right: 10,
          data: this.legendData
        },
        grid: {
          top: '15%',
          left: '2%',
          right: '4%',
          bottom: '1%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          // data: this.xAxisData
          data: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
        },
        yAxis: {
          type: 'value'
        },
        series: [{
          data: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
          // data: this.seriesData,
          type: 'bar',
          barWidth: 20
        }]
      };
      this.chart.setOption(this.option);
      this.chart.on('click', function (param) {
        console.log('param', param);

        _this2.$emit('showBarData', param);
      });
    }
  }
};